<template>
  <div class="wrapper">
    <div class="headline text-center">
      <img :src="ENV.VITE_APP_BRAND_NAME === 'EMMA' ? emmaLogo : logo" />
      <h4>
        {{ t("modules.keycloak.SetupUser.headline1") }}
        <br />
        {{ t("modules.keycloak.SetupUser.headline2") }}
      </h4>
      <h4>
        {{ t("modules.keycloak.SetupUser.subline1") }}
      </h4>
      <div>
        <LISAButton
          :loading="blockRetry"
          icon="fas fa-refresh"
          :label="
            blockRetry
              ? t('modules.keycloak.SetupUser.input.refresh.label1')
              : t('modules.keycloak.SetupUser.input.refresh.label2')
          "
          class="mr-2"
          @click="retry"
        />
        <LISAButton
          icon="fas fa-unlock"
          :label="t('modules.keycloak.SetupUser.input.logout.label1')"
          severity="secondary"
          @click="logout"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useTranslation } from "@/language/translation";

import { useStore } from "vuex";
import logo from "@/assets/logos/lisa.png";
import emmaLogo from "@/assets/logos/emma.png";
import LISAButton from "@/components/shared/primevue/LISAButton.vue";
import { ref } from "vue";
import { ENV } from "@/ENV";
const store = useStore();

function logout() {
  store.dispatch("login/logout");
}

const blockRetry = ref(false);
async function retry() {
  blockRetry.value = true;
  const user = await store.dispatch("login/recoverSession");
  let isSetupNeeded: {
    state: boolean;
    token: string;
  };
  if (user === false) {
    // check if setup is needed
    isSetupNeeded = store.getters["login/needSetup"];
  } else {
    isSetupNeeded = { state: false, token: "" };
    store.dispatch("login/setSetup", isSetupNeeded);
  }
  if (isSetupNeeded.state === false) {
    // setup is not needed
    window.open(window.location.origin, "_self");
  }
  setTimeout(() => {
    blockRetry.value = false;
  }, 10000);
}

const { t } = useTranslation();
</script>

<style lang="scss" scoped>
.wrapper {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 4rem;
  > .headline {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    > img {
      max-width: 70%;
    }
  }
}
</style>
